<form (keyup.enter)="login()" (ngSubmit)="login()" [formGroup]="form" class="container">
  <section class="login">
    <div class="login_box">
      <div class="left">
        <div class="contact">
          <div>
            <h4> Hello Sitter | Admin Panel </h4>
            <small *ngIf="errorMessage" style="color: red; font-style: italic;">{{ errorMessage }}</small>

            <input (change)="errorMessage = null" autofocus formControlName="login" placeholder="Login"
                   required style="margin-bottom: 0;" type="text">
            <small *ngIf="form.controls['login'].invalid && (form.controls['login'].dirty || form.controls['login'].touched)"
                   style="color: red; font-style: italic;">Login
              is required.</small>

            <input (change)="errorMessage = null" formControlName="password" placeholder="Password"
                   required style="margin-bottom: 0;" type="password">
            <small *ngIf="form.controls['password'].invalid && (form.controls['password'].dirty || form.controls['password'].touched)"
                   style="color: red; font-style: italic;">Password
              is required.</small>

            <button [disabled]="isLoginDisabled" class="submit">Sign in</button>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right-text">
          <!--          <h2>Hello peace of mind.</h5>-->
          <!--          <h5>Welcome to the app that’s changing what it means to find the right babysitter in New York.-->
          <!--            Now serving New Orleans.</h5>-->
        </div>
      </div>
    </div>
  </section>
</form>
